import React from "react"
import {useLang} from "./Metronici18n"
import {IntlProvider} from "react-intl"

import {AR, FR} from "../constants"

const translationsFiles = [
  "authentication",
  "error",
  "user-management",
  "template-contrats",
  "partnership-service",
  "classroom",
  "educational-repository",
  "folder-management",
  "school-dropout",
  "pedagogic-support",
  "cursus-phases",
  "home",
  "menu",
  "referential",
  "settings",
  "address",
  "general",
  "validation",
  "activity",
  "pfi"
]

const _loadTranslation = (lang) => {
  let translations = {}

  for (let translationFile of translationsFiles){
    const object = require(`./../locales/${lang}/${translationFile}.json`)
    translations = Object.assign({}, translations, object)
  }

  return translations
}

const frMessages = _loadTranslation("fr")
const arMessages = _loadTranslation("ar")

export const allMessages = {
  [AR]: arMessages,
  [FR]: frMessages
}

export const I18nProvider = ({ children }) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}
